import React from 'react';
import { useSurveyStore } from '../../surveyutilities/surveyStore';
import { QuestionHeading, QuestionPreviewField } from './QuestionBlockShared';

function RatingBlock({ block, position }) {
    const updateQuestion = useSurveyStore((state) => state.updateQuestion);
    const maxValue = block.maxValue || 5;
    const minValue = block.minValue || 1;
    const ratingType = block.ratingType || 'stars';

    return (
        <div className="ecx-survey-q">
            <QuestionHeading block={block} position={position} />

            <QuestionPreviewField>
                <div className="ecx-survey-q__rating" onClick={(e) => e.stopPropagation()}>
                    <select
                        className="form-select form-select-sm ecx-survey-q__rating-type"
                        value={ratingType}
                        onChange={(e) =>
                            updateQuestion(block.internalId, { ratingType: e.target.value })
                        }
                    >
                        <option value="stars">Stars</option>
                        <option value="numbers">Numbers</option>
                        <option value="scale">Scale</option>
                    </select>

                    {ratingType === 'stars' ? (
                        <div className="ecx-survey-q__stars">
                            {Array.from({ length: maxValue }, (_, index) => (
                                <i
                                    key={index}
                                    className={`bi ${index < 3 ? 'bi-star-fill' : 'bi-star'}`}
                                />
                            ))}
                        </div>
                    ) : null}

                    {ratingType === 'numbers' ? (
                        <div className="ecx-survey-q__numbers">
                            {Array.from({ length: maxValue - minValue + 1 }, (_, index) => (
                                <span key={index} className="ecx-survey-q__number-pill">
                                    {minValue + index}
                                </span>
                            ))}
                        </div>
                    ) : null}

                    {ratingType === 'scale' ? (
                        <div className="ecx-survey-q__scale">3 / {maxValue}</div>
                    ) : null}

                    <div className="ecx-survey-q__rating-labels">
                        <span>{block.minLabel || 'Poor'}</span>
                        <span>{block.maxLabel || 'Excellent'}</span>
                    </div>
                </div>
            </QuestionPreviewField>
        </div>
    );
}

export default RatingBlock;
